export default "__VITE_ASSET__DHSjAkiY__"